/**
 * @author Vladislavs Zimnikovs <vladislavs.zimnikovs@scandiweb.com>
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package puma-mx
 */

import PropTypes from 'prop-types';
import { Children, PureComponent } from 'react';

import { ChildrenType } from 'Type/Common.type';

import TabsComponent from './Tabs.component';

/** @namespace Scandipwa/Component/Tabs/Container */
export class TabsContainer extends PureComponent {
    static propTypes = {
        children: ChildrenType.isRequired,
        htmlName: PropTypes.string,
        // eslint-disable-next-line react/boolean-prop-naming
        renderInactiveTabButtons: PropTypes.bool
    };

    static defaultProps = {
        htmlName: '',
        renderInactiveTabButtons: false
    };

    state = {
        activeTab: this._initActiveTab()
    };

    containerFunctions = {
        onTabClick: this.onTabClick.bind(this)
    };

    _initActiveTab() {
        const { children } = this.props;

        children.forEach((child) => {
            if (child) {
                const { props: { id } } = child;

                return id;
            }

            return null;
        });
    }

    containerProps = () => {
        const { htmlName, renderInactiveTabButtons } = this.props;

        return {
            tabList: this._getTabIdArray(),
            activeTab: this._getActiveTab(),
            htmlName,
            renderInactiveTabButtons
        };
    };

    onTabClick(tabId) {
        this.setState({ activeTab: tabId });
    }

    _getTabIdArray() {
        const { children } = this.props;

        return Children.map(children, (child) => {
            if (!child) {
                return null;
            }

            const { props: { id, label } = {} } = child;

            return { id, label };
        }) || [];
    }

    _getActiveTab() {
        const { activeTab } = this.state;

        return activeTab;
    }

    render() {
        const { children } = this.props;

        return (
            <TabsComponent { ...this.containerProps() } { ...this.containerFunctions }>
                { children }
            </TabsComponent>
        );
    }
}

export default TabsContainer;
